import React, { useEffect, useState } from 'react'

// react redux
import { connect } from 'react-redux'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// react router dom
import { Link, useHistory } from 'react-router-dom';

// react bootstrap
import { Container, Spinner } from 'react-bootstrap'

// API
import { getGoogleShoppingSettings, setGoogleShoppingCategories } from 'utlis/Apis/GoogleShopping_API';

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// toast
import { toast } from 'react-toastify'

// listing
import CategoriesListing from '../../commonIncludes/CategoriesListing'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function Settings(props) {

    // props
    const { authState, setGlobalLoading } = props

    // store url
    const [storeUrl] = useStoreUrl()

    // consts
    const history = useHistory()

    // states
    const [categoryValue, setCategoryValue] = useState("")
    const [productCondition, setProductCondition] = useState("New")
    const [productBreadcrumbs, setProductBreadcrumbs] = useState("")
    const [productCount, setProductCount] = useState("")

    const [submitButtonDisable, setSubmitButtonDisable] = useState(false)
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)


    // handle Product Condition Change
    const handleProductConditionChange = ev => {
        const inpVal = ev.target.value

        setProductCondition(inpVal)
    }

    // when submit button gets clicked
    const handleSubmitBtnClick = ev => {
        ev.preventDefault()

        // loading
        setSubmitButtonDisable(true)
        setSubmitButtonLoading(true)

        const requiredData = {
            category: categoryValue,
            breadcrumb: productBreadcrumbs,
            product_type: productCondition
        }

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // getting google categories data
        setGoogleShoppingCategories(headers, requiredData).then(res => {
            // loading
            setSubmitButtonDisable(false)
            setSubmitButtonLoading(false)

            const resData = res.data

            // if request is success
            if (resData?.success) {
                const dataToUse = resData.data
                setCategoryValue(dataToUse.category) // setting default category value
                setProductCondition(dataToUse.product_type) // setting product type
                setProductBreadcrumbs(dataToUse.breadcrumb) // setting product breadcrumbs
                setProductCount(dataToUse.total_products) // setting product product count

                // dismissing all the toasts
                toast.dismiss();

                // showing the toast
                toast.success("Details updated successfully", {
                    autoClose: 2500
                })
            }

            // if request is error
            if (resData?.error) {
                // dismissing all the toasts
                toast.dismiss();

                // showing the toast
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }

        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getGoogleShoppingCategories `, err.message)

            // dismissing all the toasts
            toast.dismiss();

            // showing the toast
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // loading
                    setSubmitButtonDisable(false)
                    setSubmitButtonLoading(false)
                }
            })
        })
    }

    useEffect(() => {
        // loading
        setGlobalLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getGoogleShoppingSettings(headers).then(res => {
            // loading
            setGlobalLoading(false)

            const resData = res.data

            // if request is success
            if (resData?.success) {
                const dataToUse = resData.data
                setCategoryValue(dataToUse.category) // setting default category value
                setProductCondition(dataToUse.product_type) // setting product type
                setProductBreadcrumbs(dataToUse.breadcrumb) // setting product breadcrumbs
                setProductCount(dataToUse.total_products) // setting product product count
            }

            // if request is error
            if (resData?.error) {
                // dismissing all the toasts
                toast.dismiss();

                // showing the toast
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }

        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getGoogleShoppingSettings `, err.message)

            // dismissing all the toasts
            toast.dismiss();

            // showing the toast
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // loading
                    setGlobalLoading(false)
                }
            })
        })
    }, [authState, setGlobalLoading])

    // get selected category
    const getSelectedCategory = data => {
        if (data) {
            setCategoryValue(data)
        }
    }

    return (
        <section id="app-google-shopping-settings" className="st-def-mar-TB">
            <Container fluid className="st-container">
                {/* back button */}
                <div className="page-save-button-block d-flex align-items-center mb-1">
                    {/* BACK BUTTON WRAPPER */}
                    <div className="back-button-wrapper st-line-height-0">
                        <Link to="/"
                            className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600"
                            onClick={ev => {
                                ev.preventDefault()

                                history.goBack()
                            }}>
                            <FeatherIcon
                                icon="arrow-left"
                                size="16"
                                className="icon me-1" />
                            <span>Back</span>
                        </Link>
                    </div>

                    {/* SAVE BTN */}
                    <button
                        className={`st-btn st-btn-primary ms-auto ${(submitButtonDisable) ? "disabled" : ""}`}
                        disabled={submitButtonDisable}
                        onClick={ev => handleSubmitBtnClick(ev)}>
                        {
                            submitButtonLoading ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                <span>Save</span>
                            )
                        }
                    </button>
                </div>

                <div className="app-google-shopping-settings">
                    {/* header */}
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Marketplace Product Settings</p>
                        {/* <p className="app-desc">
                            Keep yourself and customers informed with automated notifications. Send order updates, remind customers about your products, and keep up with what’s happening in your store.
                        </p> */}
                    </div>

                    <div className="app-content-container">
                        {/* fixed page view */}
                        <div className="fixed-left-page-view-container google-shopping-container mb-3 mb-lg-4">
                            <div className="flpvc-inner d-flex flex-wrap">
                                {/* left sec */}
                                <div className="flpvc-lt-sec">
                                    <div className="inner">
                                        {/* heading */}
                                        <div className="app-header-wrapper heading-sm mb-3">
                                            <p className="app-heading text-capitalize mb-2">Your products on marketplaces</p>
                                            <p className="app-desc">
                                                These settings are applied to your products published on Facebook and displayed across Google.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* right sec */}
                                <div className="flpvc-rt-sec media-body ps-3">
                                    <div className="inner">
                                        {/* page border box 2 */}
                                        <div className="page-border-box2 mb-3 mb-md-4 edit-senders-info">
                                            <div className="pbb2-inner">
                                                {/* text sec */}
                                                <div className="text-sec mb-3">
                                                    {/* header */}
                                                    <div className="app-header-wrapper heading-sm mb-2">
                                                        <p className="app-heading text-capitalize mb-2">Marketplace category</p>
                                                        <p className="app-desc st-fs-14">
                                                            Categorize your products by selecting a general category that best describes all of them. This will make your products more discoverable to customers. After you set the category for the whole store, you can specify a category for a particular product in Product → Attributes.
                                                        </p>
                                                    </div>

                                                    {/* content */}
                                                    <div className="content">
                                                        <CategoriesListing
                                                            defaultValue={categoryValue}

                                                            getSelectedCategory={getSelectedCategory}
                                                        />
                                                    </div>
                                                </div>

                                                {/* text sec */}
                                                <div className="text-sec">
                                                    {/* header */}
                                                    <div className="app-header-wrapper heading-sm mb-2">
                                                        <p className="app-heading text-capitalize mb-2">Product condition</p>
                                                        <p className="app-desc st-fs-14">
                                                            Specify your products’ condition to let customers know what exactly you offer and improve your chance to sell. Select “New” if your products are brand-new and have never been used. Select “Refurbished” if they have been restored to working order. This includes, for example, remanufactured printer cartridges. Select “Used” for second-hand products, with the original packaging opened or missing.
                                                        </p>
                                                    </div>

                                                    {/* content */}
                                                    <div className="content">
                                                        <select className="select-main" value={productCondition} onChange={handleProductConditionChange}>
                                                            <option value="New">New</option>
                                                            <option value="Refurbished">Refurbished</option>
                                                            <option value="Used">Used</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* fixed page view */}
                        <div className="fixed-left-page-view-container google-shopping-container">
                            <div className="flpvc-inner d-flex flex-wrap">
                                {/* left sec */}
                                <div className="flpvc-lt-sec">
                                    <div className="inner">
                                        {/* heading */}
                                        <div className="app-header-wrapper heading-sm mb-3">
                                            <p className="app-heading text-capitalize mb-2">Category per product</p>
                                            <p className="app-desc">
                                                These settings are applied to your products published on Facebook and displayed across Google.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* right sec */}
                                <div className="flpvc-rt-sec media-body ps-3">
                                    <div className="inner">
                                        {/* page border box 2 */}
                                        <div className="page-border-box2 mb-3 mb-md-4 edit-senders-info">
                                            <div className="pbb2-inner">
                                                {/* text sec */}
                                                <div className="text-sec mb-3">
                                                    {/* header */}
                                                    <div className="app-header-wrapper heading-sm mb-2">
                                                        <p className="app-heading text-capitalize mb-2">Assigned categories per product</p>
                                                        {/* <p className="app-desc st-fs-14">
                                                            Categorize your products by selecting a general category that best describes all of them. This will make your products more discoverable to customers. After you set the category for the whole store, you can specify a category for a particular product in Product → Attributes.
                                                        </p> */}
                                                    </div>

                                                    {/* content */}
                                                    <div className="content">
                                                        <table className="table table-main">
                                                            <thead>
                                                                <tr>
                                                                    <th>Category</th>
                                                                    <th>Products</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <p>{categoryValue}</p>
                                                                    </td>
                                                                    <td>
                                                                        <a href="/" className="st-text-primary" onClick={ev => ev.preventDefault()}>
                                                                            {
                                                                                productCount ? (
                                                                                    <React.Fragment>
                                                                                        {productCount} products
                                                                                    </React.Fragment>
                                                                                ) : null
                                                                            }
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Settings)